export default __webpack_public_path__ + "static/intrepid-25f32250163c83d334dad25aeaf747a3.webp";